import { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from '~/store';
import { selectBusinessUuid } from '~/store/slices/formSlice/selectors';

interface Props {
  children: ReactElement;
  isAuthenticated: boolean;
  to?: string;
}

export default function PrivateRoute({ children, isAuthenticated, to = '/login' }: Props) {
  const { pathname } = useLocation();
  const businessUuid = useSelector(selectBusinessUuid);

  if (!isAuthenticated) {
    return <Navigate state={{ redirect: pathname }} to={to} />;
  }

  // Allow access to verification page even with pending payments
  const isVerificationPage = pathname === '/verify-subscription';

  // Allow access to verification page regardless of business setup status
  if (isVerificationPage) {
    return children;
  }

  if (!businessUuid && pathname !== '/private/accountsetup') {
    return <Navigate to="/private/accountsetup" />;
  }

  if (businessUuid && pathname === '/private/accountsetup') {
    return <Navigate to="/private/invoices" />;
  }

  return children;
}
